import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const ProjectEmployeeList = Loadable(lazy(() => import('./ProjectEmployeeList')));

const ProjectEmployeeRoutes = [
  {
    path: '/projectemployee/list',
    element: <ProjectEmployeeList />,
    auth: authRoles.admin,
  },
];

export default ProjectEmployeeRoutes;
